import * as React from 'react'
import { FC } from 'react'
import { Formik } from 'formik'
import { useActions, useData } from './hooks'
import { CreateAgreementFormFields } from './CreateAgreementFormFields'
import {
  EmbedFormManagerDrawer,
  FormActions,
} from '../../EmbedFormManagerDrawer'
import { ENTITY_TYPES } from '@sales-center/common'
import { AgreementSource } from '../typings'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  externalLocationId: string
  onClose: () => void
  openServicesDrawer: () => void
  openCreateServiceDrawer: () => void
  source?: AgreementSource
}

export const CreateAgreementFormWrapper: FC<Props> = (props) => {
  const { onClose } = props

  const { success, failed, loading, initialValues } = useData(props)

  const {
    formId,
    onSubmit,
    editDrawerOpen,
    closeEditDrawer,
    validateAgreementForm,
  } = useActions(props)

  return (
    <>
      {loading && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {success && (
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          initialTouched={false}
          validateOnChange
          validate={validateAgreementForm}
        >
          <CreateAgreementFormFields onCancel={onClose} {...props} />
        </Formik>
      )}

      {failed && (
        <Box p={2}>
          <Alert severity="error"> Failed to load agreement templates. </Alert>
        </Box>
      )}

      {!!formId && (
        <EmbedFormManagerDrawer
          action={FormActions.Edit}
          formId={formId}
          onClose={closeEditDrawer}
          open={editDrawerOpen}
        />
      )}
    </>
  )
}
CreateAgreementFormWrapper.displayName = 'CreateAgreementFormWrapper'
